import { dbStorage } from './indexedDBStorage'
import type { CameraLucidaPersistedInquiry } from '../types/cameraLucidaTypes'

type CameraLucidaInquiryDraft = Omit<CameraLucidaPersistedInquiry, 'id' | 'schemaVersion'> & {
  id?: string
}

const cameraInquiryId = (chapterId: string, createdAt: string): string => {
  const randomPart = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2)
  return `camera-lucida::${chapterId}::${createdAt}::${randomPart}`
}

export const persistCameraLucidaInquiry = async (
  draft: CameraLucidaInquiryDraft,
): Promise<CameraLucidaPersistedInquiry> => {
  const record: CameraLucidaPersistedInquiry = {
    ...draft,
    id: draft.id || cameraInquiryId(draft.chapterId, draft.createdAt),
    schemaVersion: 3,
  }
  await dbStorage.put('camera_lucida_inquiries', record)
  return record
}

export const listCameraLucidaInquiries = async (
  chapterId: string,
): Promise<CameraLucidaPersistedInquiry[]> => {
  const records = await dbStorage.getAllByIndex('camera_lucida_inquiries', 'chapterId', chapterId)
  return records.sort((left, right) => right.completedAt.localeCompare(left.completedAt))
}
